import { render } from "./InfoPlaceholder.vue?vue&type=template&id=6eb61788"
import script from "./InfoPlaceholder.vue?vue&type=script&lang=js"
export * from "./InfoPlaceholder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__